var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("background: " + (_vm.element.style.backgroundColor) + ";color:" + (_vm.element.style.color)))},[_c('div',{staticClass:"LTable",style:({
      borderTopColor: _vm.element.style.lineColor,
      borderLeftColor: _vm.element.style.lineColor,
      borderTopWidth: _vm.element.style.frameWeight + 'px',
      borderLeftWidth: _vm.element.style.frameWeight + 'px'
    })},_vm._l((_vm.element.tableData.dataList),function(item,index){return _c('div',{key:index,staticClass:"tr",style:({
        fontSize:
          (index === 0
            ? ((_vm.element.style.tableHeadFontSize * _vm.scale) / 100).toFixed(0)
            : ((_vm.element.style.tableBodyFontSize * _vm.scale) / 100).toFixed(0)) +
          'px',
        height: ((item.trHeight * _vm.scale) / 100).toFixed(0) + 'px'
      })},_vm._l((item.children),function(tdItem,tdIndex){return _c('div',{key:tdIndex,staticClass:"td",style:({
          borderBottomColor: _vm.element.style.lineColor,
          borderRightColor: _vm.element.style.lineColor,
          borderBottomWidth: _vm.element.style.frameWeight + 'px',
          borderRightWidth: _vm.element.style.frameWeight + 'px',
          width: ((tdItem.tdWidth * _vm.scale) / 100).toFixed(0) + 'px'
        })},[_vm._v(" "+_vm._s(_vm.element.tableData.tableTextType === '1' ? tdItem.value : tdItem.value.realValue)+" ")])}),0)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }